/*
* Validate required
*/
$.formUtils.addValidator({
	name: 'required',
	validatorFunction: function(val, $el, config, language, $form) {
		let type = $el.attr('type');
		switch (type) {
			case 'checkbox':
				return $el.is(':checked');
			case 'radio':
				return $form.find('input[name="' + $el.attr('name') + '"]').filter(':checked').length > 0;
			default:
				let dataType = $el.data('type');
				switch (dataType) {
					case 'table':
						return this.validateTableRequired($el);
					default:
						return $.trim(val) !== '';
				}
		}
	},
	validateTableRequired: function($el) {
		let hasSelectedItems = true;
		let manager = $el.data('manager');
		if (manager) {
			hasSelectedItems = manager.hasSelectedItems();
		}
		return hasSelectedItems;
	},
	errorMessage: '',
	errorMessageKey: 'requiredFields'
});
